"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getHydrogenBondDonorCount = getHydrogenBondDonorCount;
const getNumberProperties_1 = require("./getNumberProperties");
/**
 * Returns the hydrogen bond donor count of a compound
 *
 * @param data Data of a compound data request to the PubChem API
 * @returns ComputedData
 */
function getHydrogenBondDonorCount(data) {
    const hydrogenBondDonorCount = (0, getNumberProperties_1.getNumberProperties)(data, 'Hydrogen Bond Donor Count');
    return hydrogenBondDonorCount;
}
//# sourceMappingURL=getHydrogenBondDonorCount.js.map